import axios from 'axios';
import { ROSTER_QUALIFICATIONS_BY_COST_CENTERS } from 'RestAPIs/endpoints';
import { QualificationResponse } from './types';

export const getQualificationsByCostCenters = ({
  costCenters,
  startDate,
  endDate
}) =>
  axios.get<QualificationResponse[]>(ROSTER_QUALIFICATIONS_BY_COST_CENTERS, {
    params: {
      costCenters,
      startDate,
      endDate
    }
  });
